import http from "../../utils/http";
import * as TYPES from './action-types.js';
import {ls} from '../../store/local-store.js';
import {formatTime} from "../../utils";

export function UserService(context) {
	const disptach = context.$store.dispatch;
	const USER__SET_CAPTCHA_COUNTDOWN_ACTION = `user/${TYPES.USER__SET_CAPTCHA_COUNTDOWN}`;
	const USER__SET_USER_ACTION = `user/${TYPES.USER__SET_USER}`;
	const USER__SET_SESSION_ID_ACTION = `user/${TYPES.USER__SET_SESSION_ID}`;
	function _getUser() {
    const user = context.$store.state.user.user;
		return user && user.id ? user : ls.getItem('user');
	}
	function _getSessionId() {
		return context.$store.state.user.sessionId || ls.getItem('sessionId');
	}
	function _getCityId() {
		return context.$store.state.app.cityId;
	}
	function _getUserId() {
		let {id} = _getUser() || {};
		return id;
	}
	return {
		/**
		 * 进入个人中心
		 * @param params
		 */
		turnToUserView: (params) => {
			context.$router.push({
				name: 'User',
				params
			});
		},
		/**
		 * 进入登陆页
		 * @param params
		 */
		turnToLoginView: (params) => {
			context.$router.push({
				name: 'Login',
				params
			});
		},
		/**
		 * 发送验证码
		 * @param params
		 * @return {Promise<AxiosResponse>}
		 */
		sendCaptcha(params) {
			return http.post('/user/sendSms', params);
		},
		/**
		 * 发送语音验证码
		 */
		sendVoiceCaptcha(params) {
			return http.post('/user/sendVoiceCode', params);
		},
		/**
		 * 设置倒计时
		 * @param countdown
		 */
		setCaptchaCountdown(countdown) {
			disptach(USER__SET_CAPTCHA_COUNTDOWN_ACTION, countdown);
		},
		/**
		 * 绑定手机号
		 * @param params
		 * @return {*}
		 */
		bindMobile(params) {
			const defaultParams = {
				sessionId: _getSessionId()
			};
			return http.post('/user/bindMobile', Object.assign(defaultParams, params)).then((user) => {
				const {
					userId: id,
					mobile,
					isServiceManager,
					baseLineId
				} = user || {};
				return {
					id,
					mobile,
					isServiceManager: isServiceManager === 1,
					supportAreaIds: (baseLineId || '').split(',').map(p => parseInt(p))
				};
			});
		},
    /**
		 * 获取用户信息
		 */
		getUser() {
			return _getUser() || {}
		},
		/**
		 * 设置用户信息
		 * @param user
		 */
		setUser(user) {
			disptach(USER__SET_USER_ACTION, user);
			ls.setItem('user', user);
		},
		/**
		 * 获取用户id
		 */
		getUserId() {
			let {id} = _getUser() || {};
			return id;
		},
		/**
		 * 获取客服机账号支持的区域id列表
		 * @return {[]|*[]}
		 */
		getSupportAreaIds() {
			let {supportAreaIds = []} = _getUser() || {};
			return supportAreaIds || [];
		},
		/**
		 * 判断是否是客服机账号
		 * @return {boolean}
		 */
		isServiceManager() {
			let {isServiceManager = false} = _getUser() || {};
			return !!isServiceManager;
		},
		/**
		 * 判断用户是否已登录
		 * @return {boolean}
		 */
		isUserLogin() {
			let {id} = _getUser() || {};
			return !!id;
		},
		/**
		 * 获取用户手机号
		 */
		getUserMobile() {
			let {mobile} = _getUser() || {};
			return mobile;
		},
		/**
		 * 退出登录，清除本地用户信息
		 * @return {Q.Promise<any> | * | PromiseLike<any>}
		 */
		logout() {
			const user = _getUser();
			let {userId, sessionId} = user || {};
      if (!userId) {
        const uInfo = ls.getItem('user') || {}
        userId = uInfo.id
      }
			const params = {
				sessionId,
				userId
			};
			return http.post('/user/logout', params).then((res) => {
				disptach(USER__SET_USER_ACTION, null);
				ls.removeItem('user');
				return res;
			});
		},
		/**
		 * 从本地数据中恢复用户登录状态
		 */
		recoverLocal() {
			const user = ls.getItem('user');
			if (user) {
				disptach(USER__SET_USER_ACTION, user);
			}
		},
		/**
		 * 设置sessionId，存入本地
		 * @param sessionId
		 */
		setSessionId(sessionId) {
			disptach(USER__SET_SESSION_ID_ACTION, sessionId);
			ls.setItem('sessionId', sessionId, 604800000); // 7天
		},
		/**
		 * 获取sessionId
		 * @return {*|null}
		 */
		getSessionId() {
			return _getSessionId() || ls.getItem('sessionId');
		},
		/**
		 * 跳转到意见反馈页面
		 * @param params
		 * @param query
		 */
		turnToFeedback(params, query) {
			context.$router.push({
				name: 'Feedback',
				params,
				query
			});
		},
		/**
		 * 获取意见反馈列表
		 * @return {*}
		 */
		fetchFeedbackList() {
			return http.get(`/feedback/list?cityId=${_getCityId()}&userId=${_getUserId()}`).then(data => (data.list || []).map(item => {
				let {createTime, replyStatus, picUrls = ''} = item || {};
				return {
					...item,
					...{
						formattedCreateTime: formatTime(createTime, 'YYYY-MM-DD HH:mm'),
						statusText: ['未回复', '已回复', '已回复'][replyStatus],
						statusColor: ['#FE5959', '#666666', '#666666'][replyStatus],
						hasReply: [1, 2].indexOf(replyStatus) !== -1,
						pics: (picUrls || '').split(',').filter(p => !!p),
					}
				};
			}));
		},
		/**
		 * 提交反馈
		 * @param feedback
		 * @return {*}
		 */
		submitFeedback(feedback) {
			return http.post('/feedback/save', feedback);
		},
		/**
		 * 获取客服电话
		 * @return {*}
		 */
		fetchCityPhone() {
			return http.get(`/user/getCityPhone?cityId=${_getCityId()}`);
		},
		/**
		 * 通过手机号获取用户信息
		 * @return {*}
		 */
		fetchUserInfoByPhone(params = {}) {
			return http({
        url: '/user/login',
        params: {
          ...params,
          cityId: _getCityId()
        }
      })
		},
		/**
		 * 通过code获取用户信息
		 * @return {*}
		 */
		fetchUserInfoByCode(data = {}) {
			return http({
        url: '/user/code_login',
				method: 'post',
        data
      })
		},
	};
}

export function install(Vue, context) {
	Vue.prototype.$UserService = UserService(context);
}
